import React, { useState, useEffect } from "react";
import styles from "./ApprovalLine.module.css";
import { computeDefaultApprovalLine } from "./computeDefaultApprovalLine";

// ✅ disableAutoDefault: 기존 문서를 불러와 수정하는 화면(예: DraftDocumentNew.jsx의
// /:id/edit)에서 true로 넘긴다 — 그 화면은 별도 효과가 서버에 저장된 실제 결재선을
// 비동기로 불러와 approvers를 채우는데, 이 컴포넌트의 자동 생성 효과도 마운트 시
// "approvers가 비어있다"는 같은 조건으로 동시에 실행되면 어느 쪽 응답이 나중에
// 오느냐에 따라 저장된 실제 결재선이 자동 생성값으로 덮어써질 위험이 있다(레이스
// 컨디션). 신규 작성 화면(수정 대상 문서 없음)에서는 기본값 그대로 자동 생성한다.
export default function ApprovalLine({ approvers = [], setApprovers, onOpenModal, documentType, disableAutoDefault = false }) {  // ✅ { 추가
  console.log("✅ ApprovalLine 컴포넌트 로드됨");
  console.log("👥 현재 approvers:", approvers);

  const [searchTerm, setSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  // ✅ 페이지 진입 즉시(마운트 시) 결재선 자동 생성 규칙을 실행해 기본 결재선을
  // 바로 표시한다 — 이전엔 "지정" 버튼을 눌러 모달을 열어야만 적용됐음.
  useEffect(() => {
    // 한 번만 실행되도록 체크
    if (!isInitialized && !disableAutoDefault && approvers.length === 0) {
      loadDefaultApprovalLine();
      setIsInitialized(true);
    }
  }, []);

  // ✅ 기본 결재선 로드 함수 — 문서종류별 규칙(결의는 합의 제외, 작성자 직위에 따라
  // 상위자만 남는 것 등)은 computeDefaultApprovalLine(모달과 공유)이 전담한다.
  const loadDefaultApprovalLine = async () => {
    try {
      const defaultApprovers = await computeDefaultApprovalLine(documentType);
      console.log("📋 기본 결재선 로드됨:", defaultApprovers);
      setApprovers(defaultApprovers);
    } catch (error) {
      console.error("❌ 기본 결재선 로드 실패:", error);
    }
  };

  const handleRemove = (id) => {
    console.log("❌ 삭제 클릭됨 ID:", id);
    setApprovers((prev) => prev.filter((item) => item.id !== id));
  };
  
  // ✅ 결재 상태 변경 함수
  const handleStatusChange = (id, newStatus) => {
    console.log("🔄 상태 변경:", id, newStatus);
    setApprovers((prev) =>
      prev.map((user) =>
        user.id === id ? { ...user, status: newStatus } : user
      )
    );
  };

  // ✅ 검색 필터링
  const filteredApprovers = approvers.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (user.position && user.position.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>결재자 지정</h3>

      <div className={styles.box}>
        <div className={styles.searchRow}>
          <input
            className={styles.searchInput}
            placeholder="결재자를 지정하세요"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className={styles.addBtn}
            onClick={onOpenModal}
          >
            수정
          </button>
        </div>

        <div className={styles.list}>
          {filteredApprovers.length === 0 ? (
            <div className={styles.emptyMessage}>
              {searchTerm ? "검색 결과가 없습니다" : "결재자를 추가해주세요"}
            </div>
          ) : (
            filteredApprovers.map((user, idx) => (

              <div key={user.id} className={styles.item}>
                <div className={styles.order}>{idx + 1}</div>

                <div className={styles.contentWrap}>
                  <div className={styles.userInfo}>
                    <span className={styles.name}>{user.name}</span>
                    <span className={styles.position}>{user.position}</span>
                  </div>
                  
                  <div className={styles.badgeWrap}>
                    <button
                      className={
                        user.status === "기안"
                          ? styles.draftYellow
                          : styles.approvalGray
                      }
                      onClick={() => handleStatusChange(user.id, "기안")}
                    >
                      기안
                    </button>
                    <button
                      className={
                        user.status === "결재"
                          ? styles.approval
                          : styles.approvalGray
                      }
                      onClick={() => handleStatusChange(user.id, "결재")}
                    >
                      결재
                    </button>
                    <button
                      className={
                        user.status === "합의"
                          ? styles.agreeBlue
                          : styles.approvalGray
                      }
                      onClick={() => handleStatusChange(user.id, "합의")}
                    >
                      합의
                    </button>
                  </div>
                </div>

                <button
                  className={styles.removeBtn}
                  onClick={() => handleRemove(user.id)}
                >
                  ×
                </button>
              </div>

            ))
          )}
        </div>
      </div>
    </div>
  );
}